import {Settings} from "types/settings"

export function isBrowserSoftphone(provider: Settings.DialerProvider | string | undefined): boolean {
    return provider === Settings.DialerProvider.Twilio || provider === Settings.DialerProvider.Telnyx
}
